import type { FlightStatus } from '@/types/flight';
import styles from './SchedulePage.module.css';

/**
 * The tint class for each status.
 *
 * Per STATUS, not per tone: `statusTone` collapses fifteen statuses onto five
 * colours because a badge only has to say roughly how good the news is, and this
 * board has to be readable at a glance from across a room — where "boarding" and
 * "checking in" being different colours is the whole point.
 *
 * A `Record` over the union, so a status added to `FLIGHT_STATUSES` is a compile
 * error here rather than a row that silently loses its colour — which is how the
 * bare DEPARTED and LANDED entries here were caught the day the server dropped
 * them. Every status the API can now send has a colour; only a row whose status is
 * NULL goes untinted, and `ScheduleRow` guards for exactly that.
 *
 * Its own module because three things read it — the rows, the legend and the status
 * filter — and one map is what keeps them from disagreeing about a colour.
 */
export const TINT: Record<FlightStatus, string | undefined> = {
  EXPECTED: styles.statusExpected,
  ON_TIME: styles.statusOnTime,
  DELAYED: styles.statusDelayed,
  CHECK_IN: styles.statusCheckIn,
  BOARDING: styles.statusBoarding,
  DEPARTED_EARLY: styles.statusEarly,
  DEPARTED_ON_TIME: styles.statusFinishedOnTime,
  DEPARTED_LATE: styles.statusLate,
  LANDED_EARLY: styles.statusEarly,
  LANDED_ON_TIME: styles.statusFinishedOnTime,
  LANDED_LATE: styles.statusLate,
  CANCELLED: styles.statusCancelled,
  UNKNOWN: styles.statusUnknown,
};
